export default "__VITE_ASSET__B1qfrny9__"